import { useState } from "react";
import { LayoutDashboard, User, CalendarDays, WalletCards, PhoneCall, Users2, Circle, LogOutIcon, Loader, Clock } from "lucide-react";
import { ImagePath } from "../../common/ImagePath";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Sidebar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [openSubmenu, setOpenSubmenu] = useState(false);

    const handleLogout = (e) => {
    // e.preventDefault();
    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to logout?",
      text: "You will need to log in again to access your account.",
      showCancelButton: true,
      confirmButtonColor: "rgb(139 115 89)",
      confirmButtonText: "Yes, Logout",
      showClass: {
        popup: "animate__animated animate__zoomIn",
      },
      hideClass: {
        popup: "animate__animated animate__zoomOut",
      },
      animation: true,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("refresh_token");
        navigate("/");
      }
    });
  };

  const menuItems = [
    {
      name: "Dashboard",
      to: "/dashboard",
      icons: <LayoutDashboard size={20} />,
    },
    {
      name: "Host Management",
      to: "/host-management",
      icons: <User size={20} />,
    },
    { name: "Attendees", to: "/attendees", icons: <Users2 size={20} /> },
    {
      name: "Event Management",
      to: "/event-management",
      icons: <CalendarDays size={20} />,
    },
    {
      name: "Financial",
      icons: <WalletCards size={20} />,
      submenu: [
        {
          name: "User Transactions",
          to: "/user-transactions",
          icons: <circle size={20} />,
        },
        { name: "Payout", to: "/payout" },
      ],
    },
    { name: "Contact Us", to: "/contact-us", icons: <PhoneCall size={20} /> },
    { name: "Waiting List", to: "/waiting-list", icons: <Clock size={20} /> },
    { name: "Logout", logout:true, icons: <LogOutIcon size={20} /> },
  ];

  return (
    <div className="sidebar-wrapper">
      {/* Sidebar */}
      <div
        className={`${
          isOpen ? "w-[285px]" : "w-20"
        } bg-white shadow-lg h-screen p-8 flex flex-col transition-all duration-300 sticky z-[200]`}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-7">
          {isOpen && (
            <img className="w-[160px]" src={ImagePath.logo} alt="Logo" />
          )}
        </div>

        {/* Menu Items */}
        <nav className="flex-1">
          {menuItems.map((item, index) => (
            <div key={index}>
              {/* Parent Item */}
              <div
                onClick={() => {
                  if (item.logout) {
                    handleLogout();
                    return;
                  }
                  if (item.submenu) {
                    setOpenSubmenu(!openSubmenu);
                  } else {
                    navigate(item.to);
                  }
                }}
                className={`
                  flex items-center p-3 cursor-pointer rounded-md
                  ${isOpen ? "gap-4 justify-start" : "justify-center"}
                  ${
                    (item?.to === window.location.pathname)
                      ? "bg-[#8B7355] text-white shadow-[0_3px_9px_rgba(0,0,0,0.28)]"
                      : "text-gray-700"
                  }
                  transition-all
                `}
              >
                {item.icons}
                {isOpen && <span className="font-medium">{item.name}</span>}
              </div>

              {/* Submenu (for Financial) */}
              {item.submenu && openSubmenu && isOpen && (
                <div className="ml-6 mt-1 space-y-2">
                  {item.submenu.map((sub, subIndex) => (
                    <div
                      key={subIndex}
                      className={`
                        p-3 text-gray-600 cursor-pointer rounded-md 
                        transition-all font-medium
                        ${
                          sub.to === window.location.pathname ? 
                          "bg-[#8B7355] text-white shadow-[0_3px_9px_rgba(0,0,0,0.28)]" 
                          : "text-gray-700"
                        }
                      `}
                      onClick={() => navigate(sub.to)}
                    >
                      <div className="flex items-center gap-2"><Circle size={8} /><span> {sub.name}</span></div>
                     
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
